module.exports = __webpack_public_path__ + "img/axe-battle.b922a2e5.svg";